document.addEventListener('DOMContentLoaded', function () {

    const popupEl = document.getElementById('popup-canva_popup_retention');
    if (!popupEl) return;

    // ========== helpers ==========
    function hasAnyUtmInUrl() {
      try {
        const sp = new URLSearchParams(window.location.search);
        for (const key of sp.keys()) {
          if (key && String(key).toLowerCase().startsWith('utm_')) return true;
        }
      } catch (e) {}
      return false;
    }
 
    function applyVariant() {
        const hasUtm = hasAnyUtmInUrl();
        const useUtmVariant = hasUtm && paidMode === 'show';
        const hourPar = String(popupEl.dataset.hourPar || '').trim(); // "0" o "1"
        const baseIsAlt = (hourPar !== '0');

        // --- text1 ---
        const txt1El = popupEl.querySelector('[data-ret-text1]');
        if (txt1El) {
            const tDefault = txt1El.getAttribute('data-text1-default') || '';
            const tAlt = txt1El.getAttribute('data-text1-alt') || '';
            const tUtm = txt1El.getAttribute('data-text1-utm') || '';
            const base = baseIsAlt ? (tAlt || tDefault) : (tDefault || tAlt);
            txt1El.textContent = useUtmVariant ? (tUtm || base) : base;
        }

        // --- precio ---
        const priceEl = popupEl.querySelector('[data-ret-price]');
        if (priceEl) {
            const pDefault = priceEl.getAttribute('data-price-default') || '';
            const pAlt = priceEl.getAttribute('data-price-alt') || '';
            const pUtm = (priceEl.getAttribute('data-price-utm') || '').trim();
            const base = baseIsAlt ? (pAlt || pDefault) : (pDefault || pAlt);
            priceEl.textContent = useUtmVariant ? (pUtm || base) : base;
        }

        // --- CTA href ---
        const ctaEl = popupEl.querySelector('[data-ret-cta]');
        if (ctaEl) {
            const hDefault = (ctaEl.getAttribute('data-href-default') || '').trim();
            const hAlt = (ctaEl.getAttribute('data-href-alt') || '').trim();
            const hUtm = (ctaEl.getAttribute('data-href-utm') || '').trim();
            const base = baseIsAlt ? (hAlt || hDefault) : (hDefault || hAlt);
            const finalHref = useUtmVariant ? (hUtm || base) : base;
            if (finalHref) ctaEl.setAttribute('href', finalHref);
        }
    }

    // ========== paid traffic mode (default|hide|show) ==========
    const paidModeRaw = String(popupEl.dataset.paidPopupMode || 'default').trim().toLowerCase();
    const paidMode = (paidModeRaw === 'hide' || paidModeRaw === 'show' || paidModeRaw === 'default')
      ? paidModeRaw
      : 'default';

    const pageId = `${location.host}${location.pathname}`;
    const SESSION_BLOCK_KEY = `popup_retention_blocked_session__${pageId}`;

    const hasUtm = hasAnyUtmInUrl();

    try {
      if (paidMode === 'hide' && hasUtm) {
        sessionStorage.setItem(SESSION_BLOCK_KEY, '1');
      } else if (paidMode === 'show') {
        sessionStorage.removeItem(SESSION_BLOCK_KEY);
      }
    } catch (e) {}

    try {
      if (sessionStorage.getItem(SESSION_BLOCK_KEY) === '1') {
        jQuery("#popup-canva_popup_retention").stop(true, true).hide();
        jQuery("body").removeClass('body_overf');
        return;
      }
    } catch (e) {}

    // Antes de cualquier show, aplicamos variante (texto/link)
    applyVariant();

    // ========== lógica original de 2da visita + cooldown ==========
    const KEY_LAST_VISIT = `last_visited_clip_mkt2025_retention__${pageId}`;
    const KEY_LAST_SHOWN = `popup_retention_last_shown__${pageId}`;
    const COOLDOWN_HOURS = 12;

    function horasDesde(dateString) {
      const t = new Date(dateString).getTime();
      if (isNaN(t)) return Infinity;
      return (Date.now() - t) / (1000 * 60 * 60);
    }

    function mostrar_popup_r() {
      // por si cambió el URL (SPA) antes de mostrar, volvemos a aplicar
      applyVariant();

      jQuery("body").addClass('body_overf');
      jQuery("#popup-canva_popup_retention").fadeIn(300).css('display', 'flex');
      localStorage.setItem(KEY_LAST_SHOWN, new Date().toISOString());
    }

    jQuery(function () {
      const lastVisit = localStorage.getItem(KEY_LAST_VISIT);
      const lastShown = localStorage.getItem(KEY_LAST_SHOWN);

      const isNewUser = !lastVisit;
      const enCooldown = lastShown && horasDesde(lastShown) < COOLDOWN_HOURS;

      // 1) Nuevos: NO mostrar (solo registrar visita)
      if (!isNewUser) {
        // 2) Recurrentes: mostrar si no está en cooldown
        if (!enCooldown) {
          mostrar_popup_r();
        }
      }

      // 3) Siempre registrar/actualizar última visita
      localStorage.setItem(KEY_LAST_VISIT, new Date().toISOString());

      // Cerrar
      jQuery("#cerrar_retention").on('click', function () {
        jQuery("#popup-canva_popup_retention").fadeOut(300);
        jQuery("body").removeClass('body_overf');
        window.scrollTo(0, 0);
      });
    });
  });